
import './App.css';
import Routes  from './components/Routes';

function App() {
  
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
